export default {
  title: {
    offerLetterManagement: 'Offer Letter Management',
    offerLetterInviteRecordManagement: 'Offer Template',
    offerLetterTemplateList: 'Offer Template',
    offerLetterTemplateAdd: 'Add Offer Template',
    offerLetterTemplateEdit: 'Edit Offer Template',
    offerLetterTemplateView: 'View Offer Template',
    offerLetterTemplateFieldList: 'Offer Fields',
    offerLetterTemplateFieldEdit: 'Edit Offer Field',
    offerLetterTemplateFieldAdd: 'Add Offer Field',
    offerLetterInviteRecordList: 'Offer Invitation Record'
  },
  label: {
    templateName: 'Name',
    templateStatus: 'Status',
    contentLabel: 'Offer Template',
    templateFieldKey: 'Input Field Name',
    templateFieldCnName: 'Chinese Name',
    templateFieldEnName: 'English Name',
    templateFieldCreateType: 'Type',
    templateFieldValueType: 'Field Value Type',
    systemTemplateField: 'System Field',
    hrCreateTemplateField: 'Custom Field',
    templateFieldStatus: 'Status',
    templateFieldRequired: 'Required',
    offerLetterField: 'Offer Fields',
    offerLetterTemplate: 'Offer Template',
    offerLetterInviteRecord: 'Offer Invitation Record',
    inviteOfferLetterDate: 'Invite Date',
    inviteCompany: 'Company',
    inviteJobName: 'Job',
    inviteOfferLetterTemplate: 'Offer Template',
    inviteRecruiter: 'Recruiter',
    inviteCandidate: 'Candidate',
    inviteOfferLetterStatus: 'Status',
    templateFieldType: 'Input By',
    templateFieldHR: 'Recruiter',
    templateFieldCandidate: 'Candidate',
    companyName: 'Company Name',
    addOption: 'Add Field Value',
    editOption: 'Edit Field Value'
  },
  btn: {
    add: 'Add',
    view: 'View',
    openTemplateFieldList: 'Template Field List',
    export: 'Export',
    sendNotice: 'Send Reminder',
    resendInvite: 'Re-Offer'
  },
  message: {
    templateHeaderRequired: 'Header image is required',
    templateKeyRequired: 'Required info',
    templateNameRequired: 'Name is required',
    keyIsEnglish: 'Input Field Must be English',
    deleteOption: 'Are you sure you want to delete the field value {cnName}-{enName}?'
  },
  placeholder: {
    search: 'Search'
  },
  upload: {
    pc: {
      tip: 'Add PC Header Image',
      subTip: 'Recommended Size is: 1100*380 ( < 5MB )'
    },
    mobile: {
      tip: 'Add Mobile Header Image',
      subTip: 'Recommended Size is: 750*450 ( < 5MB )'
    }
  },
  INVITE_STATUS: {
    INVITED: 'Invited',
    ACCEPTED: 'Accepted',
    REJECTED: 'Declined'
  },
  OFFER_EVENT_STATUS: {
    INVITED: 'Offer Letter Sent',
    ACCEPTED: 'Offer Letter Accepted',
    REJECTED: 'Offer Letter Rejected',
    RE_INVITED: 'Re-offer',
    REMINDED: 'Offer Letter Reminded'
  },
  OFFER_LETTER_TEMPLATE_FIELD_TYPE: {
    DATE: 'Date',
    SELECT: 'Multi list',
    SIGN: 'Sign',
    SINGLE: 'Drop-down list',
    TEXT: 'Single-line text',
    TEXTAREA: 'Multi-line text'
  }
}
